import { render } from "./MenuMobile.vue?vue&type=template&id=631b7e9d&scoped=true"
import script from "./MenuMobile.vue?vue&type=script&lang=js"
export * from "./MenuMobile.vue?vue&type=script&lang=js"

import "./MenuMobile.vue?vue&type=style&index=0&id=631b7e9d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-631b7e9d"]])

export default __exports__